module.exports = __webpack_public_path__ + "static/media/slider5img.87506c1d.jpg";